module.exports = __webpack_public_path__ + "media/shared/desnivel-plano-icon-714d9e10.png";